<div class="topHead">
    <h2>Change Password</h2>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="changePasswordWrap">
    <form [formGroup]='changePasswordForm'>
        <div class="form-group">
          <input type="password" class="form-control" autocomplete="off" formControlName='old_password' id="exampleInputEmail1" aria-describedby="emailHelp" 
          placeholder="Enter Old Password" [ngClass]="{ 'is-invalid': submitted && f.old_password.errors }">
          <small class="text-error">Error</small>
          <div *ngIf="submitted && f.old_password.errors" class="invalid-feedback">
            <div *ngIf="f.old_password.errors.required">Please enter your old password to continue</div>
        </div> 
        <div *ngIf="submitted && errorInfo.isError == true">
          <span  class="text-mute text-danger errorText">Old password does not match</span>
      </div>
        </div>
        <div class="form-group">
          <input type="password" class="form-control" autocomplete="off" id="exampleInputPassword1" formControlName='new_password' 
          placeholder="Enter New Password" [ngClass]="{ 'is-invalid': submitted && f.new_password.errors }">
          <small class="text-error">Error</small>
          <div *ngIf="submitted && f.new_password.errors" class="invalid-feedback">
            <div *ngIf="f.new_password.errors.required">Please enter your new_password to continue</div>
            <div *ngIf="f.new_password.errors.minlength">Password must be at least 6 characters</div>
            <div *ngIf="f.new_password.errors.maxlength">Password must be less than or equal to 10 characters</div>
        </div>
        </div>
        <!-- admin -->
        <div class="d-block text-center">
        <button type="submit" class="btn btn-link second-link d-inline-block"  [routerLink]="['/user']" >Cancel</button>
        <button type="submit" (click)="changePass(changePasswordForm.value)" class="btn btn-primary d-inline-block">Change New Password</button>
      </div>
      <input type="hidden" (click)="open(suucessPassword)" id="successPass">
      </form>
  </div>
  <ng-template #suucessPassword let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <p class="size18">{{suucessPassMsg}}</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
  </ng-template>
  <ngx-spinner>
    <p style="color: white"> Loading... </p>
  </ngx-spinner>
  